import { useEffect, useRef } from "react";
import { Brain, MessageSquarePlus, Search, Settings } from "lucide-react";

type Props = {
  open: boolean;
  onClose: () => void;
  onNewChat: () => void;
  onMemory: () => void;
  onSettings: () => void;
};

export function CommandPalette({ open, onClose, onNewChat, onMemory, onSettings }: Props) {
  const input = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (open) input.current?.focus();
  }, [open]);
  useEffect(() => {
    const keydown = (event: KeyboardEvent) => event.key === "Escape" && onClose();
    document.addEventListener("keydown", keydown);
    return () => document.removeEventListener("keydown", keydown);
  }, [onClose]);
  if (!open) return null;
  const action = (callback: () => void) => { callback(); onClose(); };
  return (
    <div className="command-backdrop" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="command-card" role="dialog" aria-modal="true" aria-label="Палитра команд">
        <label className="command-search"><Search /><input ref={input} placeholder="Команда" /></label>
        <button type="button" onClick={() => action(onNewChat)}><span><MessageSquarePlus /> Новый чат</span><kbd>N</kbd></button>
        <button type="button" onClick={() => action(onMemory)}><span><Brain /> Память</span><kbd>M</kbd></button>
        <button type="button" onClick={() => action(onSettings)}><span><Settings /> Настройки</span><kbd>S</kbd></button>
      </section>
    </div>
  );
}

